(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("learningItemAddWebinar", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: {
                wizard: "="
            },
            templateUrl: "app/learningItems/add/steps/learningItemType/learningItemAddWebinarView.html",
            controller: ["$scope", "$localStorage", "calendarSettingsService", "$window", "_", LearningItemAddWebinarCtrl],
            controllerAs: "vm"
        };
        function LearningItemAddWebinarCtrl($scope, $localStorage, calendarSettingsService, $window, _) {
            var vm = this;
            vm.$onInit = function () {
                vm.form = vm.wizard.formData.specificInfo;
                vm.showErrors = vm.wizard.vm.showErrors;
                if (!vm.form.initialized) {
                    vm.form.webinarTypeId = 1;
                    vm.form.enabledLocalizations = $localStorage.tenantSettings.enabledLocalizations;
                    vm.form.archiveDetails = [];
                    vm.form.showForm = false;
                    vm.form.initialized = true;
                }
            };
            vm.lang = $localStorage.tenantSettings.defaultLocalization.id;
            //Date picker config
            vm.format = "yyyy-MM-dd";
            calendarSettingsService.calendarSetup($scope);
            vm.open = calendarSettingsService.openToggle;
            //Date picker Config
            vm.datePickerList = [];
            //Future Date Validation
            vm.checkDate = calendarSettingsService.checkDate;
            vm.removeArchive = function (archive) {
                vm.form.archiveDetails = _.without(vm.form.archiveDetails, archive);
            };
            vm.clearArchives = function () {
                vm.form.archiveDetails = _.reject(vm.form.archiveDetails, function (item) {
                    if (!item.url && !item.date)
                        return item;
                    return null;
                });
            };
            vm.addAnotherArchiveDetail = function () {
                vm.form.showForm = true;
                vm.showErrors = false;
                var id;
                if (vm.form.archiveDetails.length === 0) {
                    id = 1;
                }
                else {
                    id = _.max(_.pluck(vm.form.archiveDetails, "id")) + 1;
                }
                vm.datePickerList[id] = false;
                vm.form.archiveDetails.push({
                    "id": id, "date": "", "localizationId": vm.lang, "url": ""
                });
            };
            vm.loadArchiveDetail = function () {
                vm.form.showForm = true;
                if (vm.form.archiveDetails.length === 0)
                    vm.addAnotherArchiveDetail();
            };
            vm.goToLink = function (archiveDetail) {
                var url = archiveDetail.url;
                if (url) {
                    if (url.indexOf("http://") > -1 || url.indexOf("https://") > -1 || url.indexOf("ftp") > -1) {
                        $window.open(url, "_blank");
                    }
                    else {
                        archiveDetail.url = "http://" + archiveDetail.url;
                        $window.open(archiveDetail.url, "_blank");
                    }
                }
                else {
                    vm.showErrors = true;
                }
            };
        }
    });
}());
